export default "__VITE_ASSET__PMuhf6in__"